import Glide from '@glidejs/glide';

class GlideCarousel extends HTMLElement {
  connectedCallback() {
    this.glideElements = [];
    this.initializeCarousel();
  }

  initializeCarousel() {
    for (const item of this.carouselElements) {
      let glideElement = new Glide(item, this.options);
      this.glideElements.push(glideElement.mount());
    }
  }
}

export default GlideCarousel;
